function numberToStringCurrency(money) {
  return money.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export { numberToStringCurrency };
